var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
import { EOrderBookTabs, orderBookStatus, } from "@frameworks/web/components/features/OrderBook/constant";
export var eqSipOrderbookMapper = function (data) {
    var _a;
    var result = {
        type: "",
        resLst: [],
    };
    if (data && (data === null || data === void 0 ? void 0 : data.resLst)) {
        result = {
            type: data === null || data === void 0 ? void 0 : data.type,
            resLst: (_a = data === null || data === void 0 ? void 0 : data.resLst) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                var _a, _b;
                return __assign(__assign({}, x), { stDt: moment(x === null || x === void 0 ? void 0 : x.stDt).format("DD-MMM-YY"), leDt: moment(x === null || x === void 0 ? void 0 : x.leDt).format("DD-MMM-YY"), sts: ((_a = orderBookStatus[EOrderBookTabs.CLOSEORDER]) === null || _a === void 0 ? void 0 : _a.includes((_b = x === null || x === void 0 ? void 0 : x.sts) === null || _b === void 0 ? void 0 : _b.toLowerCase()))
                        ? x === null || x === void 0 ? void 0 : x.sts
                        : "Open" });
            }),
        };
    }
    return { data: result };
};
